import React from "react";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";
import data from "../data.json";

const HomeHero = () => {
  const { hero } = data.homeContent;

  return (
    <div className="relative w-full min-h-screen flex items-center overflow-hidden">
      <video
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      >
        <source
          src={`${process.env.PUBLIC_URL}/videos/homepage-background.mp4`}
          type="video/mp4"
        />
      </video>
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/20" />

      <div className="relative z-10 container mx-auto px-4 max-w-6xl py-24">
        <div className="max-w-3xl">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight tracking-tight"
          >
            {hero.heading}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-gray-100 leading-relaxed mb-8"
          >
            {hero.description}
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 mb-10"
          >
            <RouterLink
              to="/contact"
              className="inline-flex items-center justify-center bg-custom-blue hover:bg-custom-red text-white font-semibold py-3 px-6 rounded transition duration-300"
            >
              Request a Consultation
              <ArrowRight className="w-5 h-5 ml-2" />
            </RouterLink>
            <RouterLink
              to="/services"
              className="inline-flex items-center justify-center bg-white hover:bg-custom-red hover:text-white text-custom-blue font-semibold py-3 px-6 rounded transition duration-300"
            >
              Explore Services
            </RouterLink>
          </motion.div>
          <motion.ul
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="flex flex-col sm:flex-row sm:flex-wrap gap-x-8 gap-y-3"
          >
            {hero.highlights.map((highlight) => (
              <li key={highlight} className="flex items-center text-gray-100">
                <CheckCircle className="w-5 h-5 text-white mr-2 flex-shrink-0" />
                {highlight}
              </li>
            ))}
          </motion.ul>
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
